module.exports = __webpack_public_path__ + "img/chevron.c75887b7.svg";